import { Route } from '@angular/router';
import { LoginGuard } from './guard/login.guard';
import { NoLoginGuard } from './guard/no-login.guard';
import LayoutComponent from './pages/layout/layout.component';
import MyPagePage from './pages/my-page/my-page.page';

export const appRoutes: Route[] = [
  {
    path: '',
    component: LayoutComponent,
    children: [
      {
        path: '',
        loadComponent: () => import('./pages/main/main.page'),
      },
      {
        path: 'login',
        canActivate: [NoLoginGuard],
        children: [
          {
            path: '',
            loadComponent: () => import('./pages/auth/login/login.page'),
          },

          {
            path: 'find-id',
            loadComponent: () => import('./pages/auth/find-id/find-id.page'),
          },
          {
            path: 'find-password',
            loadComponent: () =>
              import('./pages/auth/find-password/find-password.page'),
          },
        ],
      },
      {
        path: 'sign-up',
        children: [
          {
            path: '',
            loadComponent: () => import('./pages/auth/sing-up/sign-up.page'),
          },
        ],
      },
      {
        path: 'my-page',
        canActivate: [LoginGuard],
        component: MyPagePage,
        children: [
          {
            path: '',
            redirectTo: 'profile',
            pathMatch: 'full',
          },
          {
            path: 'profile',
            loadComponent: () =>
              import('./pages/my-page/my-page-info/my-page-info.page'),
          },
          {
            path: 'profile/updateInfo',
            loadComponent: () =>
              import(
                './pages/my-page/my-page-profile/my-page-profile.component'
              ),
          },
          {
            path: 'history',
            loadComponent: () =>
              import('./pages/my-page/my-page-history/my-page-history.page'),
          },
          {
            path: 'activity',
            loadComponent: () =>
              import('./pages/my-page/my-page-activity/my-page-activity.page'),
          },
        ],
      },
      {
        path: 'product',
        children: [
          {
            path: '',
            loadComponent: () => import('./pages/product/product.page'),
          },

          {
            path: ':id',
            loadComponent: () =>
              import('./pages/product/product-detail/product-detail.page'),
          },

          {
            path: 'category/:id',
            loadComponent: () =>
              import('./pages/product/more-packages/more-packages.page'),
            children: [
              {
                path: ':id',
                loadComponent: () =>
                  import('./pages/product/more-packages/more-packages.page'),
              },
            ],
          },
        ],
      },
      {
        path: 'reservation',
        children: [
          {
            path: 'create',
            canActivate: [LoginGuard],
            children: [
              {
                path: ':productId',
                loadComponent: () =>
                  import(
                    './pages/reservation/create-reservation/create-reservation.page'
                  ),
              },
              {
                path: ':productId/:departureId',
                loadComponent: () =>
                  import(
                    './pages/reservation/create-reservation/create-reservation.page'
                  ),
              },
            ],
          },
          {
            path: 'update',
            canActivate: [LoginGuard],
            children: [
              {
                path: ':id',
                loadComponent: () =>
                  import(
                    './pages/reservation/create-reservation/create-reservation.page'
                  ),
              },
            ],
          },
          {
            path: ':id',
            loadComponent: () =>
              import(
                './pages/reservation/detail-reservation/detail-reservation.component'
              ),
          },
        ],
      },
      {
        path: 'magazine',
        children: [
          {
            path: '',
            loadComponent: () => import('./pages/magazine/magazine.page'),
          },
          {
            path: ':id',
            loadComponent: () =>
              import('./pages/magazine/detail-magazine/detail-magazine.page'),
          },
        ],
      },
      {
        path: 'gallery',
        children: [
          {
            path: '',
            loadComponent: () => import('./pages/gallery/gallery.page'),
          },
          {
            path: ':id',
            loadComponent: () =>
              import('./pages/gallery/detail-gallery/detail-gallery.page'),
          },
        ],
      },
      {
        path: 'customer',
        children: [
          {
            path: '',
            loadComponent: () => import('./pages/customer/customer.page'),
          },
          {
            path: 'notice/:id',
            loadComponent: () =>
              import(
                './pages/customer/notice/detail-notice/detail-notice.page'
              ),
          },
          {
            path: 'inquiry/create',
            canActivate: [LoginGuard],
            loadComponent: () =>
              import(
                './pages/customer/inquiry/create-inquiry/create-inquiry.page'
              ),
          },
          {
            path: 'inquiry/update/:id',
            canActivate: [LoginGuard],
            loadComponent: () =>
              import(
                './pages/customer/inquiry/create-inquiry/create-inquiry.page'
              ),
          },
          {
            path: 'inquiry/:id',
            loadComponent: () =>
              import(
                './pages/customer/inquiry/detail-inquiry/detail-inquiry.page'
              ),
          },
        ],
      },
      {
        path: 'policy',
        children: [
          {
            path: ':type',
            loadComponent: () =>
              import('./pages/layout/footer/terms/terms.component'),
          },
        ],
      },

      {
        path: 'not-found',
        loadComponent: () => import('./pages/not-found/not-found.page'),
      },
    ],
  },

  {
    path: '**',
    redirectTo: '/not-found',
  },
];
